import { render, staticRenderFns } from "./FundManage.vue?vue&type=template&id=4250e2ec&scoped=true&"
import script from "./FundManage.vue?vue&type=script&lang=js&"
export * from "./FundManage.vue?vue&type=script&lang=js&"
import style0 from "./FundManage.vue?vue&type=style&index=0&id=4250e2ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4250e2ec",
  null
  
)

export default component.exports